import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ImplementerSnapshotSummary } from '../../../../models/implementer/implementer.models';
import { ImplementerService } from '../../../../services/implementer/implementer.service';
import { DateTime } from 'luxon';

@Component({
  selector: 'implementer-merge-wizard-step-two',
  templateUrl: 'implementer-merge-wizard-step-two.html'
})
export class ImplementerMergeWizardStepTwoComponent {
  @Input() snapshotSummary: ImplementerSnapshotSummary;

  @Output()
  public clickNextStep: EventEmitter<void> = new EventEmitter();

  @Output()
  public previousStepClick: EventEmitter<void> = new EventEmitter();

  text: string;
  loading: boolean;

  jackingFormsModified: boolean;
  timeZoneChangeDetected: boolean;

  constructor(
    private implementerService: ImplementerService
  ) {

  }

  async onStepEnter() {
    this.loading = true;
    if (this.snapshotSummary) {
      const timeStart = DateTime.local();

      await Promise.all([
        this.checkTimeZoneChangeLoggedSinceImplementerStart(),
        this.checkJackingFormsModified(),
      ]);

      // if api call returns faster than 2 seconds, setTimeout to wait until 2 seconds, minus what the api call took
      // so the user can actually see what's happening and it doesn't just flash up and disappear
      if ((DateTime.local().toMillis() - timeStart.toMillis()) / 1000 < 2) {
        setTimeout(() => {
          this.loading = false;
        }, 2000 - (DateTime.local().toMillis() - timeStart.toMillis()));
      } else {
        this.loading = false;
      }
    }
  }

  async checkTimeZoneChangeLoggedSinceImplementerStart() {
    this.timeZoneChangeDetected = await this.implementerService.checkTimeZoneChangeDetectedinceImplementerStart();
  }

  async checkJackingFormsModified() {
    this.jackingFormsModified = await this.implementerService.checkJackingFormsModifiedSinceDate(this.snapshotSummary.creationTime);
  }

  nextStepClick() {
    this.clickNextStep.emit();
  }

  goBackClick() {
    this.previousStepClick.emit();
  }
}



// WEBPACK FOOTER //
// ./src/pages/implementer/implementer-merge/implementer-merge-wizard-step-two/implementer-merge-wizard-step-two.ts